import React, { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';

type Props = PropsWithChildren<{
  to: React.RefObject<SVGGElement | HTMLElement>;
}>;

export const Portal: React.FC<Props> = ({ to, children }) => {
  return to.current && ReactDOM.createPortal(children, to.current);
};
